import { SW_EVENTS } from "../pwa.constants";
import { PWA_EVENTS } from "../pwa.events";
import type { IPushNotification, IWorkerInfo } from "../pwa.types";

export function registerServiceWorker() {
  /* eslint-disable no-console */
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("SW registered: ", registration.scope);
        PWA_EVENTS.WorkerRegistered.next(true);
        /** Check waiting workers */
        if (registration.waiting?.state === "installed") {
          PWA_EVENTS.WorkerInstalled.next();
        }
        /** Listen activate waiting worker  */
        PWA_EVENTS.ActivateWorker.subscribe(() => {
          registration.waiting?.postMessage?.({ event: SW_EVENTS.Activate });
        });
        /** Request worker for info */
        navigator.serviceWorker.controller?.postMessage?.({ event: SW_EVENTS.Info });
        navigator.serviceWorker.addEventListener("message", (event) => {
          switch (event.data.event) {
            case SW_EVENTS.Install: {
              PWA_EVENTS.WorkerInstalled.next();
              break;
            }
            case SW_EVENTS.Activate: {
              PWA_EVENTS.WorkerActivated.next();

              break;
            }
            case SW_EVENTS.Notify: {
              const notification = event.data.data as IPushNotification;
              PWA_EVENTS.Notification.next(notification);
              break;
            }
            case SW_EVENTS.Info: {
              const info = event.data.data as IWorkerInfo;
              PWA_EVENTS.WorkerInfo.next({ date: info.date, version: info.version });
              break;
            }
            default: {
            }
          }
        });
      })
      .catch((error: unknown) => {
        console.log("SW error: ", error);
      });
  }
}
